import {apiUrl} from "../urls";
import {useEffect} from "react";
import usePost from "../axios/usePost";
import {findInCache, updateCache} from "../helpers/cacheUtils";
import {clone} from "../../utils/misc/helpers";
import {Booking} from "../../model/Booking";


const useAdvanceBooking = (myBookings: Booking[], cruiseBookings: Booking[], setMyBookings: Function, setCruiseBookings: Function) => {
  const {
    data,
    setData,
    loading: advanceBookingLoading,
    postData: advanceBooking,
  } = usePost(apiUrl.bookings + "/advance/");

  useEffect(() => {
    if (data) {
      const postResponse = data as Booking;
      if (findInCache(postResponse.id, cruiseBookings)){
        const cacheClone = clone(cruiseBookings);
        updateCache([postResponse], cacheClone);
        setCruiseBookings(cacheClone);
        if (findInCache(postResponse.id, myBookings)) {
          const myBookingsClone = clone(myBookings);
          updateCache([postResponse], myBookingsClone);
          setMyBookings(myBookingsClone);
        }
      } else {
        const cacheClone = clone(myBookings);
        updateCache([postResponse], cacheClone);
        setMyBookings(cacheClone);
      }
      setData(null);
    }
  }, [data, myBookings, setMyBookings, cruiseBookings, setCruiseBookings, setData])

  return {advanceBookingLoading, advanceBooking}
}

export default useAdvanceBooking;